import { STAT_PARTS } from './statParts';
import type { StatStyleConfig } from './types';

const BASE_STYLE = {
  label: {
    color: 'feature.secondary',
    fontWeight: 'heavy',
    fontSize: 'sm',
    lineHeight: 'sm',
    textTransform: 'uppercase',
    pb: 0.25,
  },
  helpText: { color: 'feature.secondary', pb: 0.25 },
  number: {
    verticalAlign: 'baseline',
    fontWeight: 'heavy',
    pb: 0.25,
  },
  icon: { marginEnd: 0.5, w: 1.5, h: 1.5, verticalAlign: 'middle' },
};

const SIZES = {
  lg: {
    number: { fontSize: '2xl', lineHeight: '2xl' },
  },
  md: {
    number: { fontSize: 'xl', lineHeight: 'xl' },
  },
  sm: {
    number: { fontSize: 'md', lineHeight: 'md' },
  },
};

const VARIANTS = {
  default: {
    number: {
      fontFamily: 'default',
    },
  },
  data: {
    number: {
      fontFamily: 'data',
    },
  },
};

const DEFAULT_PROPS = {
  size: 'md',
  variant: 'default',
} as const;

export const STAT_STYLE_CONFIG: StatStyleConfig = {
  parts: STAT_PARTS,
  baseStyle: BASE_STYLE,
  sizes: SIZES,
  variants: VARIANTS,
  defaultProps: DEFAULT_PROPS,
};
